const BASE = 1000;

const BYTES_PER_KB = BASE;
const BYTES_PER_MB = BASE ** 2;
const BYTES_PER_GB = BASE ** 3;
const BYTES_PER_TB = BASE ** 4;

export const fileSizeConverter = {
  bytesToKB: (sizeInBytes: number): number => sizeInBytes / BYTES_PER_KB,
  bytesToMB: (sizeInBytes: number): number => sizeInBytes / BYTES_PER_MB,
  bytesToGB: (sizeInBytes: number): number => sizeInBytes / BYTES_PER_GB,
  bytesToTB: (sizeInBytes: number): number => sizeInBytes / BYTES_PER_TB,
  GBToBytes: (sizeInGB: number): number => Math.round(sizeInGB * BYTES_PER_GB),
};
